import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null = checking, false = anon
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const cached = localStorage.getItem("s3d_user");
    const hasToken = !!localStorage.getItem("s3d_token");
    // Ottimistico: se abbiamo già una sessione salvata, mostra subito l'utente
    // (così su Wi-Fi lento l'app parte lo stesso) e verifica in background.
    if (cached) {
      try { setUser(JSON.parse(cached)); } catch { /* ignore */ }
      setLoading(false);
    }
    api
      .get("/auth/me")
      .then((r) => {
        setUser(r.data);
        localStorage.setItem("s3d_user", JSON.stringify(r.data));
      })
      .catch((err) => {
        const status = err?.response?.status;
        // Solo una sessione realmente invalida (401/403) sblogga.
        if (status === 401 || status === 403) {
          localStorage.removeItem("s3d_token");
          localStorage.removeItem("s3d_user");
          setUser(false);
        } else if (!cached) {
          // Errore di rete e nessuna sessione salvata: anonimo se non c'è token.
          if (!hasToken) setUser(false);
        }
        // Errore di rete con sessione salvata/token: mantieni l'utente loggato.
      })
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    // Store token as a resilient fallback (cookie is primary; header keeps
    // sessions working across environments where the cookie isn't delivered).
    if (data.access_token) localStorage.setItem("s3d_token", data.access_token);
    localStorage.setItem("s3d_user", JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    localStorage.removeItem("s3d_token");
    localStorage.removeItem("s3d_user");
    try { await api.post("/auth/logout"); } catch { /* ignore */ }
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);

export function formatApiError(detail) {
  if (detail == null) return "Si è verificato un errore. Riprova.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
